export default "__VITE_ASSET__BPtZZ70c__"